function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Custom Preset 24");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Custom-Preset-24",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "hand-swipe",
  transform: "translate(0.000000, 18.000000)",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M99.3047547,68.9414158 L99.3146437,68.9314704 C91.6758481,64.1029619 81.4759551,65.0179419 74.8260006,71.7062466 L71.3304484,75.2269305 L71.3304484,10.4454345 C71.3304484,4.97544555 66.8806647,0.5 61.4420403,0.5 C56.0034158,0.5 51.5585764,4.97544555 51.5585764,10.4454345 L51.5585764,49.7914816 C49.7539419,47.5637043 47.0296854,46.1116708 43.9494463,46.1116708 C41.808606,46.1116708 39.8358685,46.8177967 38.2191138,47.9863852 L16.9244269,60.3833694 L16.9392596,60.408233 C13.9974581,62.1287932 11.9999997,65.2914414 11.9999997,68.9513613 L11.9999997,85.3066284 C11.9999997,103.089065 26.3283031,117.5 44.0087768,117.5 C52.5721382,117.5 60.3295943,114.098661 66.0698153,108.588891 L66.0747595,108.633645 L99.9475017,74.5655591 C101.351656,73.1533074 101.351656,70.8608847 99.9425577,69.448633 C99.7447887,69.2497243 99.5321887,69.0756792 99.3047547,68.9414158 Z",
  id: "Path",
  fill: "#FFFFFF",
  transform: "translate(56.500000, 59.000000) scale(-1, 1) translate(-56.500000, -59.000000) "
}), React.createElement("path", {
  d: "M19.921735,21.8401878 L30,21.8401878 C31.6568542,21.8401878 33,20.497042 33,18.8401878 L33,14.1115333 C33,12.4546791 31.6568542,11.1115333 30,11.1115333 L19.921735,11.1115333 C18.2648808,11.1115333 16.921735,9.7683876 16.921735,8.1115333 L16.921735,4.80576665 C16.921735,3.36782991 15.756057,2.20215186 14.3181202,2.20215186 C13.6255655,2.20215186 12.9615484,2.47807364 12.4729429,2.96888597 L1.10733229,14.3858317 C-0.05799764,15.5564251 -0.057856651,17.4487989 1.1076477,18.6192186 L12.4552438,30.0146719 C13.4739762,31.0377006 15.1291505,31.0411835 16.1521792,30.0224512 C16.6448057,29.5318935 16.921735,28.8653116 16.921735,28.1700939 L16.921735,24.8401878 C16.921735,23.1833335 18.2648808,21.8401878 19.921735,21.8401878 Z",
  id: "Path",
  fill: "#0ABBEF"
}), React.createElement("path", {
  d: "M89.6883079,21.8538082 L99.7665729,21.8538082 C101.423427,21.8538082 102.766573,20.5106624 102.766573,18.8538082 L102.766573,14.1251537 C102.766573,12.4682995 101.423427,11.1251537 99.7665729,11.1251537 L89.6883079,11.1251537 C88.0314537,11.1251537 86.6883079,9.78200799 86.6883079,8.12515369 L86.6883079,4.81938704 C86.6883079,3.3814503 85.5226299,2.21577225 84.0846931,2.21577225 C83.3921384,2.21577225 82.7281213,2.49169403 82.2395158,2.98250636 L70.8739052,14.3994521 C69.7085753,15.5700455 69.7087162,17.4624193 70.8742206,18.632839 L82.2218167,30.0282923 C83.2405491,31.051321 84.8957234,31.0548039 85.9187521,30.0360716 C86.4113786,29.5455139 86.6883079,28.878932 86.6883079,28.1837143 L86.6883079,24.8538082 C86.6883079,23.1969539 88.0314537,21.8538082 89.6883079,21.8538082 Z",
  id: "Path",
  fill: "#0ABBEF",
  transform: "translate(86.383286, 16.506810) rotate(-180.000000) translate(-86.383286, -16.506810) "
})));

var SvgHandSwipe = function SvgHandSwipe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "105px",
    height: "136px",
    viewBox: "0 0 105 136",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHandSwipe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hand-swipe.d275fb14.svg";
export { ForwardRef as ReactComponent };